const ToastEnum = {
    Info: 'info',
    Error: 'error',
};
export default ToastEnum;
//# sourceMappingURL=ToastEnum.js.map